<!--人文美育-视频库管理-->
<template>
    <div class="sub-fus-container" >
        <div class="by-base-create-container">
            <!--创建-->
            <div class="head-container">
                <div class="left-head-container" @click="backList">
                    <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{bookData.className}}</div>
                <div class="left-head-container">
                </div>
            </div>
            <div class="info-container">
                <div class="info-container-l">
                    <el-scrollbar class="scrollbar-container">
                        <div class="unit-container" v-for="item in unitList" :key="item.classId">
                            <div :class="this.unitId&&this.unitId.includes(item.classId)?'unit-container-title-active':'unit-container-title'"
                                 @click="selUnitItem(item.classId,'',[],1)">
                                {{item.className}}
                            </div>
                            <div class="unit-item-container">
                                <div :class="this.itemId&&this.itemId.includes(i.classId)?'unit-item-active':'unit-item'" v-for="i in item.childrenList" :key="i"
                                     @click="selUnitItem(item.classId,i.classId,i.childrenList,2)">
                                    {{i.className}}
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
                <div class="info-container-r">
                    <el-scrollbar class="vl-container" v-if="itemLevel===1||!itemList||itemList.length===0">
                        <div class="video-box">
                            <div class="video-item" v-for="item in videoList">
                                <div class="item-p1">
                                    <div class="video-cover">

                                        <img alt="" :src="item.coverUrl" class="v-img">
                                    </div>
                                    <div class="video-name">
                                        {{item.title}}
                                    </div>
                                </div>
                                <div class="item-p2">
                                    <div class="player-container">
                                        <div class="player-container">
                                            <img alt="" @click="viewVideo(item)" class="img-100" src="../../assets/icon/img/player.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="videoList&&videoList.length===0">
                            <dataEmpty title="暂无视频" />
                        </div>
                    </el-scrollbar>

                    <el-scrollbar class="vl-container" v-if="itemLevel===2&&itemList&&itemList.length>0">
                        <div class="classify-container" v-for="item1 in itemList">
                            <!-- 第一层-->
                            <div class="item-level1-container">
                                <div class="item-level1-title">{{item1.className}}</div>
                                <!-- 第一层视频显示-->
                                <div class="div-100" v-if="(!item1.childrenList||item1.childrenList.length===0)&&!judgeIsVideo(item1.classId)">
                                    <dataEmpty title="暂无视频" />
                                </div>
                                <div class="video-box" style="margin-top: 5px;margin-bottom: 5px;" v-if="(!item1.childrenList||item1.childrenList.length===0)&&judgeIsVideo(item1.classId)">
                                    <div class="video-item" v-for="v1 in filterLevelVideo(item1.classId)">
                                        <div class="item-p1">
                                            <div class="video-cover">
                                                <img alt="" :src="v1.coverUrl" class="v-img">
                                            </div>
                                            <div class="video-name">
                                                {{v1.title}}
                                            </div>
                                        </div>
                                        <div class="item-p2">
                                            <div class="player-container">
                                                <div class="player-container">
                                                    <img alt="" @click="viewVideo(v1)" class="img-100" src="../../assets/icon/img/player.png">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 第二层-->
                            <div class="item-level2-container" v-if="item1.childrenList&&item1.childrenList.length>0"
                                 v-for="item2 in item1.childrenList">
                                <div class="item-level2-title">{{item2.className}}</div>
                                <!-- 第二层视频显示-->
                                <div class="div-100" v-if="(!item2.childrenList||item2.childrenList.length===0)&&!judgeIsVideo(item2.classId)">
                                    <dataEmpty title="暂无视频" />
                                </div>
                                <div class="video-box" style="margin-top: 5px;margin-bottom: 5px;" v-if="(!item2.childrenList||item2.childrenList.length===0)&&judgeIsVideo(item2.classId)">
                                    <div class="video-item" v-for="v2 in filterLevelVideo(item2.classId)">
                                        <div class="item-p1">
                                            <div class="video-cover">
                                                <img alt="" :src="v2.coverUrl" class="v-img">
                                            </div>
                                            <div class="video-name">
                                                {{v2.title}}
                                            </div>
                                        </div>
                                        <div class="item-p2">
                                            <div class="player-container">
                                                <div class="player-container">
                                                    <img alt="" @click="viewVideo(v2)" class="img-100" src="../../assets/icon/img/player.png">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 第三层-->
                                <div class="item-level3-container" v-if="item2.childrenList&&item2.childrenList.length>0" v-for="item3 in item2.childrenList">
                                    <div class="item-level3-title">{{item3.className}}</div>
                                    <!-- 第三层视频显示-->
                                    <div class="div-100" v-if="(!item3.childrenList||item3.childrenList.length===0)&&!judgeIsVideo(item3.classId)">
                                        <dataEmpty title="暂无视频" />
                                    </div>
                                    <div class="video-box" style="margin-top: 5px;margin-bottom: 5px;" v-if="(!item3.childrenList||item3.childrenList.length===0)&&judgeIsVideo(item3.classId)">
                                        <div class="video-item" v-for="v3 in filterLevelVideo(item3.classId)">
                                            <div class="item-p1">
                                                <div class="video-cover">
                                                    <img alt="" :src="v3.coverUrl" class="v-img">
                                                </div>
                                                <div class="video-name">
                                                    {{v3.title}}
                                                </div>
                                            </div>
                                            <div class="item-p2">
                                                <div class="player-container">
                                                    <div class="player-container">
                                                        <img alt="" @click="viewVideo(3)" class="img-100" src="../../assets/icon/img/player.png">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>

    <el-dialog class="ar-dialog" :title="videoName" v-model="isViewVideoShow"
               top="8vh"
               width="830px" @close="destroyed">
        <div id="player"></div>
    </el-dialog>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import { infoBook } from "@/api/admin/classLibrary";
import dataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "subjectFusion",
    props:{
        classId:{
            type: String,
            default:null
        },
    },

    components: {dataEmpty},
    data() {
        return {
            showMode:'page',
            serviceUrl,
            isViewVideoShow:false,
            token: this.$storage.get("token"),
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            videoName:'',
            videoWidth:800,
            videoHeight:500,
            itemLevel:3,
            // classId:'',
            bookData:{},
            unitList:[],
            videoList:[],
            allVideoList:[],
            unitId:'',
            itemId:'',
            filterId:'',
            bookItemId:[],
            itemList:[],
            defaultProps: {
                children: 'childrenList',
                label: 'className',
                value:'classId'
            },
            props:{
                multiple: false,
                checkStrictly: true,
                label:'className',
                value:'classId',
                children:'childrenList'
            },
        }
    },
    computed: {},
    watch: {
        classId(newValue,oldValue){
            this.queryBookInfo()
        },
    },
    created() {

    },
    mounted(){
        this.queryBookInfo()
    },
    methods: {
        backList(){
            this.$emit('change-mode', this.showMode);
        },
        viewVideo(row){
            this.vid = row.videoId;
            this.videoName = row.title;
            this.isViewVideoShow = true;
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                width: this.videoWidth,
                height: this.videoHeight,
                vid: this.vid,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
            this.isViewVideoShow = false;
        },
        queryBookInfo(){
            infoBook({ classId: this.classId }).then(res => {
                if (res.data.code === 1) {
                    this.bookData = res.data.data;
                    this.unitList = this.bookData.childrenList;
                    this.videoList = this.bookData.videoList;
                    this.allVideoList = this.bookData.videoList;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        selUnitItem(uId,iId,list,level){
            this.unitId = uId;
            this.itemId = iId;
            this.itemList = [];
            this.itemList = list;
            this.itemLevel = level;
            this.filterVideo();
        },
        filterVideo(){
            let list = [];
            if (this.unitId!==''){
                this.allVideoList.filter((item)=>{
                    if (item.courseInfo.includes(this.unitId)) {
                        list.push(item);
                    }
                })
            }
            if (this.itemId!==''){
                list = [];
                this.allVideoList.filter((item)=>{
                    if (item.courseInfo.includes(this.itemId)) {
                        list.push(item);
                    }
                })
            }
            this.videoList = list;
        },
        clearItem(){
            this.bookItemId = [];
            this.filterVideo();
        },
        changeItem(){
            if (this.bookItemId&&this.bookItemId.length>0){
                let dataId = this.bookItemId[this.bookItemId.length - 1];
                let list = [];
                this.allVideoList.filter((item)=>{
                    if (item.courseInfo.includes(dataId)) {
                        list.push(item);
                    }
                })
                this.videoList = list;
            }else {
                this.clearItem();
            }

        },
        filterLevelVideo(itemId){
            return this.allVideoList.filter((item)=>{
                return item.courseInfo.includes(itemId);
            })
        },
        judgeIsVideo(itemId){
            let list = [];
            list = this.allVideoList.filter((item)=>{
                return item.courseInfo.includes(itemId);
            })
            return list && list.length > 0;
        },
    }
}

</script>

<style scoped>
.sub-fus-container{
    width: 100%;
    height: auto;
}
.by-base-create-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    overflow-y: auto!important;
    box-sizing: border-box;
    font-family: sans-serif;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.info-container{
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    border-top: 1px solid #f1f1f1;
}
.info-container-l{
    width: 260px;
    height: 100%;
    padding: 5px 0 5px 10px;
    box-sizing: border-box;
    border-right: 1px solid #f1f1f1;
}
.scrollbar-container{
    width: 100%;
}
.unit-container{
    width: 100%;
    height: auto;
}
.unit-container-title{
    font-size: 15px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    color: #121212;
    cursor: pointer;
    padding-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.unit-container-title-active{
    font-size: 15px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    color: #ff7f2e;
    cursor: pointer;
    padding-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.unit-item-container{
    width: 100%;
    height: auto;
    //flex-wrap: wrap!important;
    //display: flex;
}
.unit-item{
    font-size: 15px;
    height: auto;
    line-height: 22px;
    color: #6a6a6a;
    //border: 1px solid #ebebeb;
    background-color: #fff;
    cursor: pointer;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
    border-radius: 4px;
    text-indent: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.unit-item-active{
    font-size: 16px;
    height: auto;
    line-height: 22px;
    color: #fff;
    border: 1px solid #ff7f2e;
    background-color: #ff7f2e;
    cursor: pointer;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
    border-radius: 4px;
    text-indent: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.info-container-r{
    width: calc(100% - 260px);
    height: 100%;
    padding: 10px 0 5px 10px;
    box-sizing: border-box;
}
.vl-container{
    width: 100%;
    height: 100%!important;
}
.video-box{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
}
.video-item{
    width: 25%;
    height: 145px;
    padding: 0 5px 0 5px;
    box-sizing: border-box;
    cursor: pointer;
    margin-bottom: 10px;
}
.item-p1{
    width: 100%;
    height: 100%;
    //position: relative;
    z-index: 1;
}
.item-p2{
    width: 100%;
    height: 100%;
    z-index: 2;
    margin-top: -145px;
    padding-top: 30px;
    box-sizing: border-box;
}
.player-container{
    width: 40px;
    height: 40px;
    margin: auto;
}
.video-cover{
    width: 100%;
    height: 109px;
    background-color: #dcdfe6;
}
.video-name{
    width: 100%;
    height: 40px;
    line-height: 16px;
    font-size: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #6a6a6a;
    padding-top: 5px;
}
.v-img{
    width: 100%;
    height: 100%;
}

/*课程层级目录*/
.classify-container{
    width: 100%;
    height: auto;
}
.item-level1-title{
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    color: #121212;
    font-family: sans-serif;
}
.item-level2-title{
    width: 100%;
    font-size: 15px;
    font-weight: bold;
    height: 24px;
    line-height: 24px;
    color: #121212;
    font-family: sans-serif;
    text-indent: 15px;
}
.item-level3-title{
    width: 100%;
    font-size: 15px;
    font-weight: bold;
    height: 24px;
    line-height: 24px;
    color: #121212;
    font-family: sans-serif;
    text-indent: 30px;
}
</style>